export default ({...props}) => {
  const {space, size, rem} = props.theme
  return `
  width: calc(${size(12.5)}%) + calc(${size(2)}px);
  .MuiStepLabel-label {
    padding-top: ${space(0.825)}px;
    padding-left: ${space(0)}px;
    word-break:break-word;
  }

  & .MuiStep-root:last-child > .MuiStepConnector-root { 
    width: ${size(12.5)}%;
  }
  @media screen and (max-width:500px){
     & [ahd_type="step"],
     & [ahd_type="currentStep"]{
      font-size:${rem(0.625)};
     }
    }
    @media screen and (max-width:395px){
      & [ahd_type="step"],
      & [ahd_type="currentStep"]{
       font-size:${rem(0.55)};
      }
     }
     @media screen and (max-width:365px){
     & [ahd_type="step"],
     & [ahd_type="currentStep"]{
      font-size:${rem(0.5)};
     }
    }

  `
}

export const progressBarStepperStyles = ({...props}) => {
  const {palette, panelHighlight, size} = props.theme
  return `
    &.MuiStepConnector-root {
      width: calc(${size(12.5)}% + ${size(0.625)}px);
      left: 0;
      right: 0;
    }

    &.Mui-active {
      & .MuiStepConnector-line {
        //border-color: ${palette.primary.main};
      }
    }

    &.Mui-completed {
      & .MuiStepConnector-line {
        border-color: ${panelHighlight.foreground};
        filter: none;
      }
    }

    & .MuiStepConnector-line {
      border-color: ${panelHighlight.foreground};
      filter: contrast(5%) brightness(195%);
      border-top-width: ${size(1)}px;
      border-radius: ${size(0.125)}px;
    }

    &.MuiStepConnector-step-failed {
      & .MuiStepConnector-line {
        border-color: ${palette.error.dark};
      }
    }
  `
}
